<div class="container-fluid">
  @if ( authUser() && ( authUser().ismanager || authUser().isadmin) )
  {
  <div class="grid col-12">
    <div class="col-4">
      @defer {
      <sortapp-novitaetendiagramm-soma></sortapp-novitaetendiagramm-soma>
      }
      @defer {
      <sortapp-notifications></sortapp-notifications>
      }
    </div>
    <div class="col-8">
      @defer {
      <app-soma-rechner-cockpit></app-soma-rechner-cockpit>
      }
    </div>
  </div>

  } @else
  { <div style="text-align: center; margin-top: 15%; ">
    <a [href]="lieferantenportaurl" style="font-size: var(--fontSizeBigger); color: var(--colorItemActive)  ">Bitte
      verwenden Sie das Lieferantenportal.</a>
  </div>
  }
</div>

<!-- <button (click)="click($event)" class="btn btn-primary">message</button> -->
